import { connect } from '../dependencies';
import { summarySelector } from '../services/selectors';
import Summary from '../components/Summary';

const mapStateToProps = summarySelector;

export default connect(mapStateToProps)(Summary);
